@for (s of sizes; track s) {
    <div #sizeDetectorDiv id="{{ s.id }}" class="{{ s.css + ' ' + (prefix + s.id) }} h-0">{{ s.name }}</div>
}
